/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Premium_Speed_TitleInputs */

const en_dialog_premium_speed_title = /** @type {(inputs: Dialog_Premium_Speed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speeds up to 4x`)
};

const es_dialog_premium_speed_title = /** @type {(inputs: Dialog_Premium_Speed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidades de hasta 4x`)
};

/**
* | output |
* | --- |
* | "Speeds up to 4x" |
*
* @param {Dialog_Premium_Speed_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_premium_speed_title = /** @type {((inputs?: Dialog_Premium_Speed_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Premium_Speed_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_premium_speed_title(inputs)
	return en_dialog_premium_speed_title(inputs)
});